import { render } from "./LeaveDetailsPanel.vue?vue&type=template&id=23a7abce&scoped=true"
import script from "./LeaveDetailsPanel.vue?vue&type=script&lang=js"
export * from "./LeaveDetailsPanel.vue?vue&type=script&lang=js"

import "./LeaveDetailsPanel.vue?vue&type=style&index=0&id=23a7abce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a7abce"]])

export default __exports__